import { useState, useEffect } from 'react';

import { SettingsItemId } from 'settings/Settings.types';
import { RBAC_PRODUCT_AREAS } from 'common/constants/rbacProductAreas';

import server from 'common/utils/server';

export type DashboardItem = {
  id: SettingsItemId;
  link: string;
  title: string;
  subtitle: string | null;
};
export type DashboardItemsState = {
  items: Array<DashboardItem> | null;
};

const dashboardItemsEndpoint = '/api/v1/settings_dashboard_items';

export function useDashboardItems() {
  const [data, setData] = useState<DashboardItemsState>({
    items: null,
  });

  useEffect(() => {
    server
      .get(dashboardItemsEndpoint, {
        product_area: RBAC_PRODUCT_AREAS.ADMIN_AND_COMPANY_SETTING,
      })
      .then((result: Array<DashboardItem>) =>
        setData(currentData => ({ ...currentData, items: result }))
      );
  }, []);

  return {
    items: data.items || [],
    loading: data.items === null,
  };
}
